import React from 'react';

const ArrowUp = props => (
  <svg width={24} height={24} {...props}>
    <path d="M1 16h22L12 7z" fillRule="evenodd" />
  </svg>
);

export default ArrowUp;
